export default __webpack_public_path__ + "static/media/alicateCrimpador.ff570800.png";